import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filters, VivoChangeEvent } from './vivo-filters.model';
import { VivoService } from '../../vivo/vivo.service';
import { forEach } from 'lodash-es';
import { Property, VivoBody } from '../vivo-filters/vivo-filters.model';
import { _ } from '../../shared/utils';
import { DateFilters, dateFilterValues } from '../filters/filters.model';
import {
  addDays,
  addMonths,
  addWeeks,
  addYears,
  isAfter,
  subDays,
  subMonths,
  subWeeks,
  subYears
} from 'date-fns/esm';

@Component({
  selector: 'qm-vivo-filters',
  templateUrl: './vivo-filters.component.html',
  styleUrls: ['./vivo-filters.component.scss']
})
export class VivoFiltersComponent implements OnInit {

  public startDate: Date;
  public endDate: Date;

  public dateTypes = dateFilterValues;
  public dateFilter: DateFilters = {
    startDate: new Date(),
    endDate: new Date(),
    selected_type: 'All'
  };

  public timedTaskes: string = _('All');

  public vivoBody: VivoBody = new VivoBody();
  public vivoTasks: {name: string, value: string}[] = [];
  private allTasks: {_id: string}[] = [];

  public selectedTask: {type: string, template_id: string} = {type: 'All', template_id: ''};

  @Output() filtersChanged: EventEmitter<VivoChangeEvent> = new EventEmitter<any>();

  constructor(private vivoService: VivoService) {
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate.setHours(23, 59, 59, 999);
  }

  ngOnInit() {
    this.getVivoVariables();
  }

  private async getVivoVariables() {
    const responses = await Promise.all([
      this.vivoService.vivoTaskType(),
      this.vivoService.getVivoUsers(),
      this.vivoService.vivoTaskPrioritys()
    ]);
    forEach(responses[0].docs, (o: any) => {
      if (o.id !== this.vivoService.getDiaryTaskType()) {
        this.vivoTasks.push({name: o.name, value: o.id});
        this.allTasks.push({_id: o.id});
      }
    });
  }

  public selectedFilterChanged() {
    this.filtersChanged.emit(new VivoChangeEvent(this.vivoBody));
  }

  public vivoTask() {
    let value: {_id: string}[];
    const temp = this.vivoBody.filters.filter(o => {
      return o.option || o.property._id !== 'taskType';
    });
    this.vivoBody.filters = temp;
    const property: Property = {
      _id: 'taskType',
      type: 'taskType'
    };
    if (this.selectedTask.type === 'All') {
      value = this.allTasks;
    } else {
      value = [{_id: this.selectedTask.template_id}];
    }
    this.vivoBody.filters.push({property, value});
    this.selectedFilterChanged();
  }

  public dueDate(v: string) {
    const date = new Date();
    this.timedTaskes = v;
    this.vivoBody = new VivoBody();
    if (v === 'Late') {
      const a: Filters = {
        property: {
          _id: 'taskStatus',
          type: 'taskStatus'
        },
        value: {name: 'taskStatus', value: 3}
      };
      this.vivoBody.filters.push(a);
      this.vivoBody.viewOptions = {
        onlyPending: true,
        orderby: 'dueDate',
        reverse: true
      };
    } else if (v === 'Before') {
      const a: Filters[] = [
        {
          property: {
            _id: 'taskStatus',
            type: 'taskStatus'
          },
          value: {name: 'taskStatus', value: 2}
        },
        {
          option: {
            value: 'after', name: 'is After'
          },
          property: {_id: 'dueDate', type: 'datetime'},
          query: [{
            key: 'date',
            value: date.toISOString()
          }],
          value: date.toISOString()
        }
      ];
      this.vivoBody.filters = a;
      this.vivoBody.viewOptions = {
        orderby: 'dueDate',
        reverse: false
      };
    } else {
      this.vivoBody.viewOptions = {
        onlyPending: false,
        orderby: 'updatedAt',
        reverse: true
      };
    }
    this.vivoTask();
  }


  public vivoDate() {
    const temp = [];
    for (const s of this.vivoBody.filters) {
      if (s.property && s.property._id === 'taskStatus') {
        temp.push(s);
      }
    }
    this.vivoBody.filters = temp;
    if (this.dateFilter.selected_type !== 'All') {
      const before: Filters = {
        property: {
          '_id': 'updatedAt',
          'type': 'datetime'
        },
        option: {
          value: 'before',
        },
        query: [{
          key: 'updatedAt',
          value: this.endDate.toISOString()
        }],
        value: this.endDate.toISOString()
      };
      const after: Filters = {
        property: {
          '_id': 'updatedAt',
          'type': 'datetime'
        },
        option: {
          value: 'after',
        },
        query: [{
          key: 'updatedAt',
          value: this.startDate.toISOString()
        }],
        value: this.startDate.toISOString()
      };
      this.vivoBody.filters.push(before, after);
    }
    this.vivoTask();
  }

  public timeTravels(direction: 'next' | 'previous' | ''): void {
    if (direction === 'next') {
      this.timeTravelsNext();
    } else if (direction === 'previous') {
      this.timeTravelsPrevious();
    } else {
      this.timeTravelsNone();
    }
  }

  private timeTravelsNext(): void {
    this.startDate = new Date(this.endDate.getTime());
    switch (this.dateFilter.selected_type) {
      case 'Day':
        this.endDate = addDays(this.startDate, 1);
        break;
      case 'Week':
        this.endDate = addWeeks(this.startDate, 1);
        break;
      case 'Month':
        this.endDate = addMonths(this.startDate, 1);
        break;
      case 'Year':
        this.endDate = addYears(this.startDate, 1);
        break;
    }
    if (this.futureCheck()) {
      this.vivoDate();
    }
  }

  private timeTravelsPrevious(): void {
    this.endDate = new Date(this.startDate);
    switch (this.dateFilter.selected_type) {
      case 'Day':
        this.startDate = subDays(this.endDate, 1);
        break;
      case 'Week':
        this.startDate = subWeeks(this.endDate, 1);
        break;
      case 'Month':
        this.startDate = subMonths(this.endDate, 1);
        break;
      case 'Year':
        this.startDate = subYears(this.endDate, 1);
        break;
    }
    this.vivoDate();
  }

  private timeTravelsNone(): void {
    switch (this.dateFilter.selected_type) {
      case 'Day':
        this.startDate = subDays(this.endDate, 1);
        break;
      case 'Week':
        this.startDate = subWeeks(this.endDate, 1);
        break;
      case 'Month':
        this.startDate = subMonths(this.endDate, 1);
        break;
      case 'Year':
        this.startDate = subYears(this.endDate, 1);
        break;
    }
    this.vivoDate();
  }

  private futureCheck(): boolean {
    const today = new Date();
    if (isAfter(this.endDate, today)) {
      this.startDate = new Date(today.getTime());
      this.timeTravelsPrevious();
      return false;
    }
    return true;
  }

}
